import type { IttCartItem } from '@hyundai/shared-lib';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { ApiTypes } from '../../..';
import { QuickfilterEntry } from './vehicle.reducer';

export const vehicleActions = createActionGroup({
    source: 'vehicle',
    events: {
        Init: props<{ initalFilter?: ApiTypes.FilterObject }>(),
        'Load Historys': emptyProps(),
        'Set History': props<{ history: ApiTypes.FilterObject }>(),
        'Set History Success': props<{ historys: QuickfilterEntry[] }>(),
        'Set History Failure': emptyProps(),

        Filter: emptyProps(),
        'Reset Filter': emptyProps(),

        'Load Quick Search': emptyProps(),

        'Load Vehicle List': emptyProps(),
        'Load Vehicle List Success': props<{ list: ApiTypes.VehicleList }>(),
        'Load Vehicle List Failure': props<{ error: string }>(),

        'Load Favorites': emptyProps(),
        'Load Favorites Success': props<{ favorites: ApiTypes.Favorites }>(),
        'Load Favorites Failure': props<{ error: string }>(),
        'Remove Favorite Vehicle': props<{ slug: string }>(),

        'Load Similar Vehicle List': emptyProps(),
        'Load Similar Vehicle List Success': props<{ list: ApiTypes.VehicleList }>(),
        'Load Similar Vehicle List Failure': props<{ error: string }>(),

        'Load Number Of Vehicles': emptyProps(),
        'Load Number Of Vehicles Success': props<{ count: number }>(),
        'Load Number Of Vehicles Failure': props<{ error: string }>(),

        'Load Vehicle Detail': props<{ slug: string }>(),
        'Load Vehicle Detail Success': props<{ vehicle: ApiTypes.VehicleDetail }>(),
        'Load Vehicle Detail Failure': props<{ error: string }>(),

        'Load Filter': emptyProps(),
        'Load Filter Success': props<{ filterInputs: ApiTypes.VehicleFilterInputs }>(),
        'Load Filter Failure': props<{ error: string }>(),

        'Load Filter Preview Number Of Vehicles': emptyProps(),
        'Load Filter Preview Number Of Vehicles Success': props<{ count: number }>(),
        'Load Filter Preview Number Of Vehicles Failure': props<{ error: string }>(),

        'Add Vehicle View': props<{ slug: string }>(),
        'Add Vehicle View Success': emptyProps(),
        'Add Vehicle View Failure': props<{ error: string }>(),

        'Load Social Proof': props<{ slug: string }>(),
        'Load Social Proof Success': props<ApiTypes.SocialProofResponse>(),
        'Load Social Proof Failure': props<{ error: string }>(),
        'Add Filter': props<{
            filterObject: ApiTypes.FilterObject;
            trackingKeys: string[];
            historyMessage: Partial<Record<keyof ApiTypes.FilterObject, string>> | null;
        }>(),
        'Add Filter And Remove Filter': props<{
            filterObject: ApiTypes.FilterObject;
            trackingKeys: string[];
            historyMessage: Partial<Record<keyof ApiTypes.FilterObject, string>> | null;
            removeFilter: ApiTypes.FilterObject;
        }>(),
        'Remove Filter': props<{ removeFilterObject: Array<keyof ApiTypes.FilterObject>; trackingKeys: string[] }>(),
        'Reset Preview Filter': emptyProps(),

        'Set Accessory Cart': props<{ newCart: IttCartItem[] }>(),
        'Open Filter': emptyProps(),

        'Set Vehicle List Position': props<{ position: number }>(),
        'Reset Vehicle List Position': emptyProps(),

        'Reset Tracking Keys': emptyProps(),
    },
});
